import { render } from "./MoneyPage.vue?vue&type=template&id=a69ed63c&scoped=true"
import script from "./MoneyPage.vue?vue&type=script&lang=js"
export * from "./MoneyPage.vue?vue&type=script&lang=js"

import "./MoneyPage.vue?vue&type=style&index=0&id=a69ed63c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a69ed63c"]])

export default __exports__